import { memo } from 'react'
import { useTranslation } from 'react-i18next'

type LiveMonitoringPillProps = {
  count: number
}

export const LiveMonitoringPill = memo(function LiveMonitoringPill({
  count,
}: LiveMonitoringPillProps) {
  const { t } = useTranslation('feed')

  if (count === 0) return null

  return (
    <span className="inline-flex items-center gap-1.5 rounded-full border border-destructive/30 bg-destructive/10 px-2.5 py-1 text-[12px] font-semibold text-destructive">
      <span className="relative flex h-2 w-2">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-destructive opacity-75" />
        <span className="relative inline-flex h-2 w-2 rounded-full bg-destructive" />
      </span>
      {t('livePill.live')}
      <span className="font-normal opacity-80">
        {t('livePill.monitoring', { count })}
      </span>
    </span>
  )
})
